import { SelectItem } from '@/types/ui';

/**
 * Expands hierarchical paths (e.g., "A__B__C") into all intermediate levels ("A", "A__B", "A__B__C")
 * to ensure parent nodes are available for selection in TreeSelect components.
 * This enables proper indication mode behavior where selecting a parent selects all its descendants.
 */
const expandHierarchicalPaths = <T extends string>(options: SelectItem<T>[]): SelectItem<T>[] => {
  const expanded: SelectItem<T>[] = [];
  const seen = new Set<string>();

  options.forEach(option => {
    const value = option.value;
    if (typeof value === 'string' && value.includes('__')) {
      const segments = value.split('__');
      let currentPath = '';
      segments.forEach(segment => {
        currentPath = currentPath ? `${currentPath}__${segment}` : segment;
        if (!seen.has(currentPath)) {
          seen.add(currentPath);
          expanded.push({ label: currentPath, value: currentPath as T });
        }
      });
    } else {
      const stringValue = String(value);
      if (!seen.has(stringValue)) {
        seen.add(stringValue);
        expanded.push(option);
      }
    }
  });

  return expanded;
};

export default expandHierarchicalPaths;
